import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

import { NavigationScroll } from '@/components/layout/NavigationScroll'

import { getOfflineDb } from './offline/db'
import Routes from './routes/Routes'
import ReloadPrompt from './ReloadPrompt'
import { RootState } from './store'
import { theme } from './themes'

const App: React.FC = () => {
  const { mode } = useSelector((state: RootState) => state.appSlice)
  const appTheme = theme(mode)

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
    }
  }, [])

  useEffect(() => {
    getOfflineDb().then(() => window.console.log('✅ IndexedDB hazır!'))
  }, [])

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <ReloadPrompt />
      <NavigationScroll>
        <Routes />
      </NavigationScroll>
    </ThemeProvider>
  )
}

export default App
